module.exports = __webpack_public_path__ + "static/media/75mmD125Inox.4d5101c1.png";